import React from 'react';
import { Link, Preloader } from 'MWComponents';
import '../less/index.less';
import DOMPurify from 'utils/sanitize';
import { canUseDOM } from '../../../../helpers/canUseDOM';

export default function template() {
    const { page, widget, usefullDocsMode, loader, noTitle, titleTag } = this.props;

    const TitleTag = titleTag || 'h2'

    if (loader) {
        return (canUseDOM ? <Preloader /> : null)
    }

    return (
      widget && widget.data && widget.data.length ?
        <div className={`files-new ${page} ${usefullDocsMode ? 'usefull' : ''}`}>
        <div className="container">
          {!noTitle && <TitleTag className={`files-new__title`}>{widget.data[0].title_ua}</TitleTag>}
          {widget.data.map((file, index) => {
            const filePath = this.changeFilesUrl(file.file_path_ua);
            const fileLink = file.link_path_ua;
            const text = file.name_ua;
            return (
              usefullDocsMode ? (
                <div key={index} className="files-new__item-usefull item-usefull-files-new">
                  <div className="item-usefull-files-new__text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(text) }}></div>
                  <a className="item-usefull-files-new__btn" href={fileLink ? fileLink : filePath} target="_blank" rel="noopener noreferrer">
                    {this.l10n('DOCS_DOWNLOAD_BLANC')}
                  </a>
                </div>
                
              ) : (
                <div key={index} className="files__item item-files-new">
                  <Link href={fileLink ? fileLink : filePath} target="_blank">
                    <div className="item-files-new__image">
                      <img src={this.changeFilesUrl(file.image_path)} alt='doc-img'></img>
                    </div>
                    <div className="item-files-new__text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(text) }}></div>
                  </Link>
                </div>
              ))
            }
          )}
        </div>
      </div>
        : ''
    );
}
